var _path, _path2;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgShareIosLine = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "bi bi-box-arrow-up",
    width: 32,
    height: 32.001,
    fill: "currentColor",
    viewBox: "0 0 32 32.001",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7 12.001a1 0.99998 0 0 0-1 0.99998v16a1 0.99998 0 0 0 1 0.99998h18a1 0.99998 0 0 0 1-0.99998v-16a1 0.99998 0 0 0-1-0.99998h-4a1 0.99998 0 0 1 0-2h4a3 2.9999 0 0 1 3 2.9999v16a3 2.9999 0 0 1-3 2.9999h-18a3 2.9999 0 0 1-3-2.9999v-16a3 2.9999 0 0 1 3-2.9999h4a1 0.99998 0 0 1 0 2z",
    fillRule: "evenodd",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.292 0.29378a1 0.99998 0 0 1 1.416 0l6 5.9999a1.0013 1.0012 0 0 1-1.416 1.416l-4.292-4.2939v17.586a1 0.99998 0 0 1-2 0v-17.586l-4.292 4.2939a1.0013 1.0012 0 1 1-1.416-1.416z",
    fillRule: "evenodd",
    strokeWidth: 2
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShareIosLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/share-ios-line.545de1ab.svg";
export { ForwardRef as ReactComponent };